import React from 'react';

// Forward any extra props (for example `form` or `onClick`) so buttons can
// explicitly target a form by id and avoid accidental cross-form submits.
const AuthButton = ({ type = 'button', disabled = false, children, ...props }) => (
  <button type={type} className="financial-button" disabled={disabled} {...props}>
    {children}
  </button>
);

export default AuthButton;
